import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormLoginService {

  constructor(private http: HttpClient) { }

  loginUser(username: string, password: string) {
    return this.http.post("/ui-login/v1/authenticate", {
      username: username,
      password: password,
      authenticationType: 2
    });
  }
}
